<template>
	<div class="message-error">
		<p class="message-error-text">{{ message }}</p>
		<button v-if="showRetry" class="message-error-retry" @click="$emit('retry')">
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<g clip-path="url(#clip0_2060_15490)">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M5.90481 0.279533C7.47808 -0.147644 9.14431 -0.0839778 10.6804 0.462006C12.2165 1.00799 13.5491 2.01023 14.4998 3.33453V1.74953C14.4998 1.55062 14.5788 1.35986 14.7195 1.2192C14.8601 1.07855 15.0509 0.999533 15.2498 0.999533C15.4487 0.999533 15.6395 1.07855 15.7801 1.2192C15.9208 1.35986 15.9998 1.55062 15.9998 1.74953V5.99953H11.7498C11.5509 5.99953 11.3601 5.92052 11.2195 5.77986C11.0788 5.63921 10.9998 5.44844 10.9998 5.24953C10.9998 5.05062 11.0788 4.85985 11.2195 4.7192C11.3601 4.57855 11.5509 4.49953 11.7498 4.49953H13.4768C12.6935 3.27402 11.5218 2.34665 10.1491 1.86576C8.7764 1.38488 7.2821 1.37829 5.90523 1.84703C4.52836 2.31577 3.34849 3.23276 2.55437 4.45131C1.76025 5.66986 1.39777 7.11954 1.52491 8.56844C1.65206 10.0173 2.26149 11.3817 3.25571 12.4434C4.24992 13.505 5.57147 14.2024 7.00894 14.4242C8.4464 14.646 9.91671 14.3792 11.1847 13.6666C12.4526 12.954 13.4449 11.8367 14.0028 10.4935C14.039 10.4004 14.0935 10.3155 14.163 10.2437C14.2325 10.1719 14.3156 10.1147 14.4075 10.0755C14.4995 10.0363 14.5983 10.0159 14.6982 10.0154C14.7981 10.0149 14.8971 10.0344 14.9894 10.0727C15.0817 10.111 15.1654 10.1674 15.2356 10.2385C15.3058 10.3096 15.361 10.394 15.3982 10.4868C15.4353 10.5795 15.4535 10.6788 15.4517 10.7787C15.4499 10.8786 15.4282 10.9771 15.3878 11.0685C14.8666 12.3231 14.0345 13.4242 12.97 14.2682C11.9055 15.1121 10.6436 15.6711 9.30323 15.8924C7.96289 16.1137 6.58827 15.9901 5.30894 15.5331C4.02962 15.0761 2.88773 14.3009 1.99092 13.2805C1.09412 12.2601 0.471931 11.0281 0.183015 9.70069C-0.105901 8.37328 -0.0520297 6.99415 0.339551 5.69332C0.731131 4.39249 1.44752 3.2128 2.42119 2.26546C3.39486 1.31811 4.59374 0.635319 5.90481 0.279533Z"
						fill="#2A2A37"
					/>
				</g>
				<defs>
					<clipPath id="clip0_2060_15490">
						<rect width="16" height="16" fill="white" />
					</clipPath>
				</defs>
			</svg>
			Попробовать снова
		</button>
	</div>
</template>

<script setup lang="ts">
defineProps({
	message: { type: String, default: 'Неизвестная ошибка' },
	showRetry: { type: Boolean, default: false }
})

defineEmits<{
	retry: []
}>()
</script>

<style lang="scss" scoped>
.message-error {
	padding: 12px 16px;
	background-color: var(--status-error-surface);
	border-radius: var(--radius-lg);
	border-bottom-left-radius: var(--radius-tail);
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: fit-content;

	&-text {
		font: var(--font-body-small);
		color: var(--status-error);
	}

	&-retry {
		display: flex;
		align-items: center;
		gap: 8px;
		background-color: var(--background-primary);
		width: fit-content;
		border-radius: var(--radius-sm);
		border: none;
		font: var(--font-body-small);
		color: var(--text-primary);
		cursor: pointer;
		padding: 4px 8px;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.8;
		}

		svg {
			flex-shrink: 0;
		}
	}
}
</style>
